<template>
  <span class="dummy-span"><slot /></span>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class DummySpan extends Vue {}
</script>
